import config from "@/config";

const SideContent = ({ data }) => {
    return (
        <div
            className="w-full lg:w-1/3 p-3 flex flex-col sticky top-24 h-fit gap-4 lg:p-4 rounded-lg bg-white shadow-lg lg:border-2">
            <h2 className="text-2xl font-bold uppercase">ỨNG VIÊN NỔI BẬT</h2>
            <hr className="border bg-green-500" />
            <div className="flex flex-col gap-4">
                {data.map((e, index) => (
                    <div
                        key={index}
                        className="flex gap-4 p-4 border-b border-gray-200 rounded-lg hover:bg-green-100 cursor-pointer">
                        <img className="w-28 h-28" src={e.avatar || config.webConfig.defaultAvatar} alt="avatar" />
                        <div className="flex flex-col justify-between">
                            <h2 className="text-xl font-bold">{e.FullName}</h2>
                            <p className="text-blue-500 text-2xl font-normal">{e.MajorName}</p>
                            <p className="font-medium">Địa chỉ: {e.LocationName}</p>
                            <p className="font-medium">Mức lương: {e.SalaryName}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className={"flex justify-center"}>
                <button className="bg-blue-500 w-3/4 transition-all font-semibold hover:bg-blue-800 text-white p-2 rounded-lg">Xem thêm</button>
            </div>
        </div>
    )
}

export default SideContent;